import { render, staticRenderFns } from "./Remittance.vue?vue&type=template&id=19666c6a&scoped=true"
import script from "./Remittance.vue?vue&type=script&lang=js"
export * from "./Remittance.vue?vue&type=script&lang=js"
import style0 from "./Remittance.vue?vue&type=style&index=0&id=19666c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19666c6a",
  null
  
)

export default component.exports